import React, { type ReactNode } from 'react';

import { Bar, Milestone, Segment, Skeleton } from './components';

import { StyledTicksMeter } from './styles';

export interface TicksMeterProps {
    children: ReactNode;
}

export function TicksMeter({ children }: TicksMeterProps) {
    return <StyledTicksMeter>{children}</StyledTicksMeter>;
}

TicksMeter.Bar = Bar;
TicksMeter.Milestone = Milestone;
TicksMeter.Segment = Segment;
TicksMeter.Skeleton = Skeleton;
